export const SET_RESUME_INITIAL_STATE = 'SET_RESUME_INITIAL_STATE';
export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES_RESUME';
export const SET_UNMOUNT_DATA = 'SET_UNMOUNT_DATA_RESUME';
export const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE';
export const UPDATE_BLOB_URL = 'UPDATE_BLOB_URL';
export const UPDATE_SECTION = 'UPDATE_SECTION';
export const UPDATE_EXPORT = 'UPDATE_EXPORT';
export const SET_PAGES = 'SET_PAGES';
export const UPDATE_HISTORY = 'UPDATE_HISTORY_RESUME';
export const RESET_HISTORY = 'RESET_HISTORY';
export const SET_RESUME_COUNTER_VALUE = 'SET_RESUME_COUNTER_VALUE';
export const SET_SAVE_STATUS = 'SET_SAVE_STATUS';
export const SET_SAVE_EVALUATE = 'SET_SAVE_EVALUATE';
export const SET_RESUME_TYPE = 'SET_RESUME_TYPE';
export const SET_RESUME_CARDS_COLLAPSE = 'SET_RESUME_CARDS_COLLAPSE';
export const SET_DRAG = 'SET_DRAG_RESUME';
export const SET_SECTION_EXPORT = 'SET_SECTION_EXPORT';
export const SHOW_ERROR = 'SHOW_ERROR';
export const UPDATE_UNUSED_URLS = 'UPDATE_UNUSED_URLS';
export const CLEAR_UNUSED_URLS = 'CLEAR_UNUSED_URLS';
export const UPDATE_REMOVE_ON_NEXT_LOAD = 'UPDATE_REMOVE_ON_NEXT_LOAD';
export const UPDATE_EVENT_TYPES = 'UPDATE_EVENT_TYPES';
export const CLEAR_BLOB_URL = 'CLEAR_BLOB_URL';
export const SET_DRAG_OVER_CORDS = 'SET_DRAG_OVER_CORDS';
export const UPDATE_DOCUMENT_NAME = 'UPDATE_DOCUMENT_NAME';
export const UPDATE_EDITED_INPUTS = 'UPDATE_EDITED_INPUTS';
export const SET_FILE_IMPORT_STATUS = 'SET_FILE_IMPORT_STATUS';
export const SET_RESUME_IMPORT_DATA = 'SET_RESUME_IMPORT_DATA';
export const UPDATE_EDITED_INPUTS_LINKEDIN_OPTIMIZER =
  'UPDATE_EDITED_INPUTS_LINKEDIN_OPTIMIZER';
export const UPDATE_EDITED_INPUTS_QUESTIONS_GENERATOR =
  'UPDATE_EDITED_INPUTS_QUESTIONS_GENERATOR';
export const SET_IMPORT_FILE_DATA = 'SET_IMPORT_FILE_DATA';
